import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Button, ButtonTypeEnum, Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export type ActionLineProps = PlatformComponentProps & {
  onClick?: () => void;
  icon: IconNameEnum;
  primaryText?: string;
  secondaryText?: string;
  content?: React.ReactNode;
  hideArrowIcon?: boolean;
};

export const ActionLine = ({
  onClick,
  icon,
  primaryText,
  secondaryText,
  content,
  className,
  hideArrowIcon = false,
}: ActionLineProps) => {
  const [block, cn] = useModuleBEM(styles, "ActionLine");

  return (
    <Button
      buttonType={ButtonTypeEnum.Tertiary}
      className={clsx(block, className)}
      onClick={onClick}
    >
      <Icon className={cn("icon")} iconName={icon} />
      {content ?? (
        <>
          <div className={cn("label")}>{primaryText}</div>
          <div className={cn("value")}>{secondaryText}</div>
        </>
      )}
      {!hideArrowIcon && (
        <Icon className={cn("arrow")} iconName={IconNameEnum.chevronRight} />
      )}
    </Button>
  );
};
